
//import {ref, defineComponent} from 'vue'
import { defineComponent } from "vue";

// import Sites from "./components/smsweb/Sites.vue";
// import SecurityOfficers from "./components/smsweb/SecurityOfficers.vue";
// import Schedule from "./components/smsweb/Schedule.vue";
// import Login from "./components/smsweb/Login.vue";
// import Companies from "./components/smsweb/Companies.vue";

export default defineComponent({
  // setup(){
  // const test = ref('AAA');
  // console.log(test.value)
  // },

  name: "App",
  components: {
    // Sites,
    // SecurityOfficers,
    // Schedule,
    // Login,
    // Companies,
  },
  devServer: {
    https: true,
  },
  data() {
    return {
      companyName:localStorage.getItem("companyNameForHeader"),
      companyIconFileName: "" +localStorage.getItem("companyIconFile"),
      
      /*we are no longer using this as a point to define variable 'smsapi_endpoint_base_url'*/
      //smsapi_endpoint_base_url: "https://localhost:44325/",
      //smsapi_endpoint_base_url:"http://emergingsols.somee.com/",//"http://emergingsols2.somee.com/",
      //smsapi_endpoint_base_url:"http://emergingsols2.somee.com/",//"http://emergingsols2.somee.com/",
      //smsapi_endpoint_base_url:"http://testingwebsite.somee.com/",//"http://emergingsols2.somee.com/",
      isLogginSuccessfull: false,
    };
  },
  methods: {
    logout() {
      this.isLogginSuccessfull = false;
      localStorage.setItem("isLogginSuccessfull", "false");
    },

    setLoginStatus(message: boolean) {
      this.isLogginSuccessfull = message;
      var isLogginSuccessfulls = localStorage.getItem("isLogginSuccessfull");
      // if (isLogginSuccessfulls != "true") {
      //console.log("this.isLogginSuccessfull", isLogginSuccessfulls);
      // }
    },
    onMessage() {
      // handle the event
      //console.log("data : ");
    },
    Carousel() {
      window.addEventListener("message", this.onMessage);
    },
  },

  computed: {},
  mounted() {
    var isloggedSuccessfully = localStorage.getItem("isLogginSuccessfull");
    if (isloggedSuccessfully == "true") this.isLogginSuccessfull = true;
    else this.isLogginSuccessfull = false;

    //console.log("this.isLogginSuccessfull", this.isLogginSuccessfull);

    this.isLogginSuccessfull = Boolean(
      localStorage.getItem("isLogginSuccessfull")
    );
    //console.log("this.isLogginSuccessfull", this.isLogginSuccessfull);
  },
});
